import { Dialog, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    width: "100%",
    maxWidth: 560,
    borderRadius: 16,
    padding: theme.spacing(3.5),
  },
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(1.5),
  right: theme.spacing(1.5),
  color: theme.palette.text.secondary,
}));
